import ax from '../axios'
import { ICurriculum, ID } from "../../constants";
import {API_URL} from "../index";

const CURRICULUM_URL = API_URL.EDUCATION_MODULE + '/curriculum'

const getCurriculums = (query: string) => {
    return ax.get(`${CURRICULUM_URL}?${query}&createdUserId=2`)
}

const getCurriculumById = (id: ID) => {
    return ax.get(`${CURRICULUM_URL}/${id}`)
}

const createCurriculum = (baseModel: ICurriculum) => {
    delete baseModel.id
    return ax.post(CURRICULUM_URL, baseModel)
}

const updateCurriculum = (baseModel: ICurriculum) => {
    const id = baseModel.id
    delete baseModel.id
    return ax.put(`${CURRICULUM_URL}/${id}`, baseModel)
}

const deleteCurriculum = (id: ID) => {
    return ax.delete(`${CURRICULUM_URL}/${id}`)
}

export {
    createCurriculum,
    getCurriculumById,
    deleteCurriculum,
    getCurriculums,
    updateCurriculum
}
